<template>
    <DButton
        :icon="buttonIcon"
        color="secondary"
        :title="buttonTitle"
        @click="cycleTheme"
    />
</template>

<script>
export default {
    name: 'DThemeToggle',
    data () {
        return {
            theme: 'light'
        }
    },
    computed: {
        effectiveDarkMode () {
            if (this.theme === 'system') {
                return window.matchMedia('(prefers-color-scheme: dark)').matches
            }
            return this.theme === 'dark'
        },
        buttonIcon () {
            if (this.theme === 'dark') return 'weather-sunny'
            if (this.theme === 'system') return 'monitor'
            return 'weather-night'
        },
        buttonTitle () {
            if (this.theme === 'light') return 'Switch to Dark Mode'
            if (this.theme === 'dark') return 'Switch to System Mode'
            return 'Switch to Light Mode'
        }
    },
    mounted () {
        this.theme = localStorage.getItem('theme') || 'light'
        this._mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
        this._mediaQueryHandler = () => {
            if (this.theme === 'system') {
                this.applyTheme()
                this.emitter.emit('theme-changed', this.effectiveDarkMode)
            }
        }
        this._mediaQuery.addEventListener('change', this._mediaQueryHandler)
        this.applyTheme()
    },
    beforeUnmount () {
        this._mediaQuery.removeEventListener('change', this._mediaQueryHandler)
    },
    methods: {
        cycleTheme () {
            if (this.theme === 'light') this.theme = 'dark'
            else if (this.theme === 'dark') this.theme = 'system'
            else this.theme = 'light'

            localStorage.setItem('theme', this.theme)
            this.applyTheme()
            this.emitter.emit('theme-changed', this.effectiveDarkMode)
        },
        applyTheme () {
            document.body.classList.toggle('dark-mode', this.effectiveDarkMode)
        }
    }
}
</script>
